import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Modal from 'react-native-modal';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;
export const ModalContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  width: 100%;
  height: ${RFPercentage(60)}px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
`;

export const CloseButton = styled.TouchableOpacity`
  margin-bottom: ${RFValue(12)}px;
`;
export const CloseButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(18)}px;
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
  margin-top: ${RFValue(16)}px;
`;

export const StationsList = styled.ScrollView`
  margin: 0 -24px;
`;
export const ModalFooter = styled.View`
  padding: 0 24px;
  padding-bottom: ${RFValue(20)}px;
`;

export const TitleInfo = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;
export const Title = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  margin-bottom: ${RFValue(6)}px;
`;
export const Subtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;
